import { Chip } from "@mui/material";
import { Close } from "@mui/icons-material";

type BonusChipProps = {
    staffAgreement: {
        receive_bonus: boolean;
        agreement_type: string;
        contract_start_date: string | null;
    } | null;
};

export const BonusChip = ({ staffAgreement }: BonusChipProps) => {
    if (!staffAgreement?.receive_bonus) {
        return <Close sx={{ color: "error.main" }} />;
    }

    const getChipLabel = () => {
        if (staffAgreement.agreement_type === "services_provider") {
            return "Recibo Verde";
        }

        if (!staffAgreement.contract_start_date) {
            return "Produtividade";
        }

        const currentYear = new Date().getFullYear();
        const contractStartYear = new Date(staffAgreement.contract_start_date).getFullYear();

        return contractStartYear < currentYear ? "Gratificação" : "Produtividade";
    };

    const chipLabel = getChipLabel();

    return <Chip label={chipLabel} color="success" />;
};
